import {fetchNewTreeData} from "../dataLoader";
import {jqGetJson} from "../../global/helpers";

export let deleteCol = {
	resizable: false,
	editable: false,
	headerName: "",
	field: "",
	width: 50,
	cellRenderer: deleteCellRenderer,
}

export function deleteCellRenderer(params) {
	let eDiv = document.createElement('div');
	eDiv.innerHTML = '<button class="button button--black"><i class="fa fa-trash"></i></button>';
	let eButton = eDiv.querySelectorAll('.button')[0];

	eButton.addEventListener('click', function () {

		k1Confirm('Opravdu chcete vybraný záznam odstranit?').then(function () {
			let changeUrl = detailLink.replace(9999999, params.data.id);
			if (changeUrl.match(/\?/)) {
				changeUrl += '&_do=remove';
			} else {
				changeUrl += '?_do=remove';
			}

			jqGetJson(changeUrl, function (data) {
				if (data.result == true) {
					staticNotification.success('Objekt byl úspěšně odstraněn.');

					if (gridSettings.treeData) {
						if (gridSettings.rowModelType === 'serverSide') {
							fetchNewTreeData(gridDataLink);
						} else {
							window.loadNewDataFromUrl(gridDataUrl);
						}
						return eDiv;
					}

					let rowNode = gridSettings.api.getRowNode(data.id);
					gridSettings.api.updateRowData({remove: [rowNode]});
				} else if (typeof data.errorMessage !== 'undefined') {
					staticNotification.error(data.errorMessage);
				} else {
					staticNotification.error('Neočekávaná chyba, opakujte prosím akci později!');
				}
			});
		}, function () {
			console.log('Zruseno.')
		});

	});

	return eDiv;
}

window.deleteCellRenderer = deleteCellRenderer